<template>
  <div class="page">
    <PageHeader>
      Валютные Пары
    </PageHeader>

    <div class="content" v-if="loaded">
      <div class="block valute-forms" style="max-width: 500px">
        <div class="header">
          <div class="title">Создание валютной пары</div>
        </div>
        <div class="content">
          <form @submit.prevent="SubmitTradePair()">
            <model-select
              :options="
                valutes.map(valute => {
                  return {
                    value: valute,
                    text: `${valute.title} - ${valute.key}`
                  };
                })
              "
              v-model="activeForm.giveValute"
              placeholder="Give valute"
              required
            >
            </model-select>
            <model-select
              :options="
                valutes.map(valute => {
                  return {
                    value: valute,
                    text: `${valute.title} - ${valute.key}`
                  };
                })
              "
              v-model="activeForm.getValute"
              placeholder="Get valute"
              required
            >
            </model-select>
            <input
              type="number"
              min="0"
              step="any"
              placeholder="Комиссия за данную валютную пару"
              v-model="activeForm.percentComission"
              required
            />
            <button type="submit">Добавить</button>
          </form>
        </div>
      </div>

      <input
        type="text"
        placeholder="Поиск по валютным парам"
        v-model="searchPair"
      />

      <br />
      <h4>Валютные пары:</h4>
      <br />
      <div class="card_container">
        <div
          class="block"
          style="width: 33%"
          v-for="(valute, index) in filteredList"
          :key="index"
        >
          <div class="header">
            <div
              class="close delete"
              v-if="session.type === 1 || session.type === -1"
              @click.prevent="RemoveValute(valute)"
            >
              Удалить
            </div>
            <div
              class="close edit"
              v-if="session.type === 1 || session.type === -1"
              @click.prevent="EditValute(valute)"
            >
              Редактировать
            </div>
            <div class="title">
              {{ valute.title }} <b>{{ valute.key }}</b>
            </div>
          </div>
          <div
            style="display: flex; align-items: center; justify-content: space-around;"
          >
            <div class="content">
              <p>{{ valute.giveValute.title }}</p>
              <p>{{ valute.giveValute.key }}</p>
              <p>Курс: {{ valute.giveValute.course }}</p>
            </div>
            <div style="display: flex; flex-direction: column;">
              <p>
                {{ Math.round(valute.transactionComission * 10000) / 10000 }}%
              </p>
              <p>--</p>
              <p>
                Фикс:
                {{
                  valute.isFixedLimit
                    ? `${valute.fixedComission}%`
                    : valute.isFixedLimit
                }}
              </p>
            </div>
            <div class="content">
              <p>{{ valute.getValute.title }}</p>
              <p>{{ valute.getValute.key }}</p>
              <p>Курс: {{ valute.getValute.course }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-modal
      :valutes="valutes"
      @save="EditTradePair"
      :tradePair="tradePair"
      v-if="showModal"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import EditModal from "../../ui/editModal.vue";
import PageHeader from "../../ui/PageHeader.vue";
//
const defaultFormData = {
  getValute: {
    value: "",
    text: ""
  },
  giveValute: {
    value: "",
    text: ""
  },
  percentComission: null
};

export default {
  name: "TradePairs",

  data: () => ({
    loaded: false,

    valute: {
      _id: false,
      title: "",
      key: "",
      bestchangeKey: "",
      categories: [],
      isGet: 1,
      isGive: 1,
      minGive: 1,
      percentGive: 0.95,
      percentGet: 1.05,
      course: "",
      image: false
    },
    searchPair: "",
    filteredTradePairs: [],
    showModal: false,
    tradePair: {},
    valuteForms: [],

    activeFormIndex: -1,
    activeForm: defaultFormData
  }),
  components: { PageHeader,
    ModelSelect,
    EditModal
  },

  computed: {
    ...mapState("auth", ["session"]),
    ...mapState("valutes", [
      "valutes",
      "valutesForms",
      "categories",
      "tradePairs"
    ]),
    filteredList() {
      return this.tradePairs.filter(post => {
        console.log(post.getValute.bestchangeKey);
        return (
          post.getValute.bestchangeKey
            .toLowerCase()
            .startsWith(this.searchPair.toLowerCase()) ||
          post.giveValute.bestchangeKey
            .toLowerCase()
            .startsWith(this.searchPair.toLowerCase())
        );
      });
    }
  },

  methods: {
    ...mapActions("valutes", [
      "getValutes",
      "getSortedValutes",
      "getTradePairs",
      "editValuteForm",
      "deleteValuteForm",
      "deleteTradePair",
      "getValuteCategories",
      "addTradePair",
      "editTradePair"
    ]),

    CancelEditValute() {
      this.valute = {
        _id: false,
        title: "",
        key: "",
        bestchangeKey: "",
        categories: [],
        isGet: 1,
        isGive: 1,
        minGive: 1,
        percentGive: 0.95,
        percentGet: 1.05,
        course: "",
        image: false
      };
      //
      this.valuteForms = [];
      //
      this.activeForm = defaultFormData;
    },

    RemoveValute(valute) {
      let accept = confirm("Удалить валюту?");
      if (accept) {
        this.deleteTradePair(valute._id)
          .then(() => this.$nextTick())
          .then(() => alert("Успешно!"))
          .then(() => window.location.reload());
      }
    },

    EditValute(valute) {
      this.tradePair = valute;
      this.showModal = true;
      // this.valuteForms = this.valutesForms.find( item => item.key == valute._id ).forms
    },
    EditTradePair(tradePair) {
      this.editTradePair(tradePair)
        .then(() => this.$nextTick())
        .then(() => alert("Успешно"))
        .then(() => (this.showModal = false))
        .then(() => window.location.reload());
    },

    RemoveValuteForm(index, form) {
      if (form._id) {
        this.deleteValuteForm({
          valuteId: this.valute._id,
          formId: form._id
        }).then(res => {
          alert("Вы успешно удалили форму!");

          this.valuteForms.splice(index, 1);
        });
      }
      //
    },

    EditValuteForm(index, form) {
      this.activeFormIndex = index;
      this.activeForm = form;
    },

    saveValuteForm() {
      // if (this.activeFormIndex < 0) {
      // 	// add
      // } else {
      // 	// save edit
      // 	this.editValuteForm({
      // 		valuteId: this.valute._id,
      // 		formId: this.activeForm._id,
      // 		formData: this.activeForm
      // 	});
      // }
    },

    SubmitTradePair() {
      const tradePair = this.activeForm;
      console.log(tradePair);
      /* 			if (tradePair._id) {
				let editValute = {
					...valute,
					categories: JSON.stringify(valute.categories)
				}

				//
				this.editValute({ id: valute._id, valute: editValute })
					.then(() => {
						this.valute.image = false
						this.$nextTick()
						.then(() => alert('Успешно!'))
					})

			} else { */
      let addTradePair = {
        ...tradePair
      };
      //
      this.addTradePair(addTradePair)
        .then(() => this.$nextTick())
        .then(() => alert("Успешно!"))
        .then(() => window.location.reload());
    },

    SubmitForm() {
      console.log(this.activeForm);
      if (this.activeFormIndex < 0) {
        // add
        this.addValuteForm({
          valuteId: this.valute._id,
          formData: this.activeForm
        })
          .then(() => {
            this.valuteForms.push(this.activeForm);
            alert("Вы успешно добавили форму валюты");
          })
          .then(() => {
            this.activeFormIndex = -1;
            this.activeForm = defaultFormData;
          });
      } else {
        // save edit
        this.editValuteForm({
          valuteId: this.valute._id,
          formId: this.activeForm._id,
          formData: this.activeForm
        })
          .then(() => {
            alert("Вы успешно изменили форму валюты");
          })
          .then(() => {
            this.activeFormIndex = -1;
            this.activeForm = defaultFormData;
          });
      }
    }
  },

  mounted() {
    Promise.all([
      this.getValutes(),
      this.getValuteCategories(),
      this.getTradePairs()
    ]).then(() => {
      this.loaded = true;
      //
      this.filteredTradePairs = this.tradePairs;
      return this.$nextTick();
    });
  }
};
</script>

<style scoped>
.delete {
  color: red;
}

.card_container {
  display: flex;
  flex-wrap: wrap;
}

.edit {
  color: orange;
}

.delete:hover,
.edit:hover {
  cursor: pointer;
}

label {
  display: block;
}
.valute-forms input {
  display: block;
  width: 400px;
  max-width: 92%;
}
.content__label {
  margin-top: 15px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/TradePairs/index.vue